import PartType from './PartType'

const ServiceTypeValues = ['DIFM-MR', 'DIFM-MR-SET', 'DIFM-HL', 'DIFM-HL-SET', 'DIFM-TL', 'DIFM-TL-SET', 'DIFM-NAT-AVG'] as const
type ServiceSkuTypeTuple = typeof ServiceTypeValues
type ServiceSkuType = ServiceSkuTypeTuple[number] | string

export const getServiceSku = (part: string, partType: PartType): ServiceSkuType => {
  const sanitizedPart = part.toLocaleLowerCase().replace(/[^a-zA-Z0-9 ]/g, '')
  const isMR = sanitizedPart.startsWith('mirror')
  const isHL = sanitizedPart.startsWith('headlight')
  const isTL = sanitizedPart.startsWith('taillight')
  const isComponent = partType === PartType.Component
  const isSet = partType === PartType.Set

  if (isMR && isComponent) {
    return 'DIFM-MR'
  }

  if (isMR && isSet) {
    return 'DIFM-MR-SET'
  }

  if (isHL && isComponent) {
    return 'DIFM-HL'
  }

  if (isHL && isSet) {
    return 'DIFM-HL-SET'
  }

  if (isTL && isComponent) {
    return 'DIFM-TL'
  }

  if (isTL && isSet) {
    return 'DIFM-TL-SET'
  }

  return ''
}

export default ServiceSkuType
